import {
  AdminPanelSettings,
  AltRoute,
  Analytics,
  BarcodeReader,
  Biotech,
  BlurCircular,
  Delete,
  EditNote,
  Email,
  Gesture,
  Grass,
  List,
  Pause,
  Person,
  Receipt,
  School,
  Search,
  Speed,
  Storm,
  type SvgIconComponent,
} from "@mui/icons-material";
import type {
  RegisteredRouter,
  ValidateLinkOptions,
} from "@tanstack/react-router";
import type { PermissionKey } from "../features/permissions/permissions";
import { Antibody, Genetic } from "./customIcons";

export type MenuItem<
  TRouter extends RegisteredRouter = RegisteredRouter,
  TOptions = unknown,
> = {
  name: string;
  link: ValidateLinkOptions<TRouter, TOptions>["to"];
  sub?: string;
  label: string;
  hidden?: boolean;
  active?: boolean;
  icon: SvgIconComponent;
  permissions?: PermissionKey[];
  badgeCable?: string;
};

export const menuItems: MenuItem[] = [
  {
    name: "dashboard",
    link: "/dashboard",
    label: "Dashboard",
    icon: Speed,
    hidden: false,
  },
  {
    name: "results",
    link: "/results",
    label: "Resultat",
    icon: Search,
  },
  {
    name: "todo",
    link: "/todo",
    label: "Listor",
    icon: List,
  },
  {
    name: "customer",
    link: "/customer",
    sub: "customers",
    label: "Kunder",
    icon: Person,
    badgeCable: "CustomerWarningsChannel",
  },
  {
    name: "lineCheck",
    link: "/lineCheck",
    label: "Linjekontroll",
    icon: AltRoute,
  },
  {
    name: "cultivation",
    link: "/cultivation",
    sub: "start",
    label: "Odlingskontroll",
    icon: BlurCircular,
  },
  {
    name: "lungmask",
    link: "/lungmask",
    sub: "start",
    label: "Lungmaskkontroll",
    icon: Gesture,
  },
  {
    name: "read",
    link: "/read",
    label: "Avläsning",
    icon: Biotech,
  },
  {
    name: "trikin",
    link: "/trikin",
    sub: "bubble",
    label: "Trikin",
    icon: Storm,
  },
  {
    name: "pcr",
    link: "/pcr",
    sub: "check",
    label: "PCR",
    icon: Genetic,
  },
  {
    name: "elisa",
    link: "/elisa",
    sub: "check",
    label: "ELISA",
    icon: Antibody,
  },
  {
    name: "disposal",
    link: "/disposal",
    sub: "dispose",
    label: "Slängkontroll",
    icon: Delete,
  },
  {
    name: "feed",
    link: "/feed",
    sub: "lists",
    label: "Foder",
    icon: Grass,
  },
  {
    name: "registration",
    link: "/registration",
    label: "Inregistrering",
    sub: "new",
    icon: EditNote,
  },
  {
    name: "quickRegistration",
    link: "/quickRegistration",
    label: "Snabbinregistrering",
    icon: BarcodeReader,
  },
  {
    name: "email",
    link: "/email",
    label: "Epost",
    icon: Email,
    badgeCable: "EmailWarningChannel",
  },
  {
    name: "invoice",
    link: "/invoice",
    sub: "invoice",
    label: "Fakturering",
    icon: Receipt,
    hidden: false,
    permissions: ["view:invoices"],
  },
  {
    name: "statistics",
    link: "/statistics",
    sub: "statistics",
    label: "Statistik",
    icon: Analytics,
  },
  {
    name: "competence",
    link: "/competence",
    sub: "general",
    label: "Kompetens",
    icon: School,
    permissions: ["admin", "examinate"],
  },
  {
    name: "unfinished",
    link: "/unfinished",
    label: "Paus",
    icon: Pause,
  },
  {
    name: "users",
    link: "/users",
    label: "Användare",
    icon: Person,
    permissions: ["admin"],
    hidden: false,
  },
  {
    name: "admin",
    link: "/admin/productViewer",
    label: "Administration",
    icon: AdminPanelSettings,
    permissions: ["admin"],
    hidden: false,
  },
  {
    name: "maintenance",
    link: "/admin/maintenance",
    label: "Underhåll",
    icon: List,
    hidden: true,
    permissions: ["admin"],
  },
];
